import React from 'react';
import Marquee from 'react-fast-marquee';

const MarqueeComponent = ({ texts }) => {
    return (
        <div >
        <Marquee gradient={false} speed={25}>
            {texts.map((text, index) => (
                <span key={index} className='my-2 mx-7 text-white mt-6 text-xl'>
                    {text} ✨
                </span>
            ))}
        </Marquee>
        </div>
    );
};

export default MarqueeComponent;
